//@ts-nocheck
import React, { useEffect, useState } from 'react'
import JobTiptapEditor from './JobTiptapEditor'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { fetchDocument } from '../../features/job/jobSlices';
import { useParams } from 'react-router-dom';
import { _baseRequest, COMMON } from '../../utils/baseApi';


function JobHome() {
  const isAsideOpen = useAppSelector((state) => state.layout.isAsideOpen);
  const { data, fetchStatus, fetchError } = useAppSelector((state: RootState) => state.job);

  const dispatch = useAppDispatch();
  const { jobId } = useParams<{ jobId: string }>();
  const { baseId } = useParams<{ baseId: string }>();
  const [recuirementLoading, setRecuirmentLoading] = useState(false);
  const [saveRecuirements, setSaveRequirements] = useState(null);

  // useEffect(() => {
  //   if (jobId && baseId) {
  //     dispatch(fetchDocument({ baseId, id: jobId }));
  //   }
  // }, [dispatch, jobId, baseId]); 

  // aplication responses 
  useEffect(() => {
    const fetchInitialData = async () => {
      if (jobId && baseId) { // Changed: only proceed if BOTH exist
        let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/jobRequirement.listParent`;
        try {
          setRecuirmentLoading(true);
          const response = await _baseRequest(fullUrl, 'GET');

          if (response.status === 200) {
            setSaveRequirements(response);
          }
        } catch (error) {
          console.error("Error fetching initial data:", error);
        } finally {
          setRecuirmentLoading(false);
        }
      }
    };

    fetchInitialData();
  }, [jobId, baseId]);



  if (fetchStatus === 'loading') {
    return <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 50px)' }}>
      <div className="simple-spinner-loader">
        <span className='!w-6 !h-6'></span>
      </div>
    </div>;
  }

  if (fetchStatus === 'failed') {
    return <div>Error: {fetchError}</div>;
  }


  return (
    <div className='mb-14 mt-5 lg:mt-[55px] h-full'>
      <JobTiptapEditor isAsideOpen={isAsideOpen}
        data={data}
        saveRecuirements={saveRecuirements}
        recuirmentLoading={recuirementLoading}
      />
    </div>



  )
}

export default JobHome